import { Component } from '@angular/core';

@Component({
  selector: 'ins-about',
  templateUrl: './about.component.html',
})
export class AboutComponent {}
